module.exports = __webpack_public_path__ + "themes/non-default/brandLogo.8f0cc9dd38921a354de7b12873f8400f.svg";